import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=596f1f66&"
import script from "./ButtonWidget.vue?vue&type=script&lang=js&"
export * from "./ButtonWidget.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
